import React, { useState, useEffect } from "react";

interface NotificationProps {
  id: number;
  text: string;
  status: "success" | "error" | "info";
  duration?: number; // Время показа уведомления в миллисекундах
}

const Notification = ({ id, text, status, duration = 5000 }: NotificationProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(false);
    setTimeout(() => setIsVisible(true), 10);

    const timer = setTimeout(() => setIsVisible(false), duration);
    return () => clearTimeout(timer);
  }, [id]);

  if (!isVisible) return null;

  const getStatusStyles = () => {
    switch (status) {
      case "success":
        return "bg-green-500 text-white";
      case "error":
        return "bg-red-500 text-white";
      case "info":
        return "bg-blue-500 text-white";
      default:
        return "";
    }
  };

  return (
    <div className={`fixed top-4 right-4 p-4 rounded shadow-lg z-50 ${getStatusStyles()}`} role="alert">
      {text}
    </div>
  );
};

export default Notification;
